var map = {
	"./template.betprofessor": 1153,
	"./template.betprofessor.tsx": 1153,
	"./template.betroyale": 1154,
	"./template.betroyale.tsx": 1154,
	"./template.default": 663,
	"./template.default.tsx": 663,
	"./template.fiestabet": 1155,
	"./template.fiestabet.tsx": 1155,
	"./template.questbet": 1156,
	"./template.questbet.tsx": 1156,
	"./template.ts": 976,
	"./template.vikingbet": 1157,
	"./template.vikingbet.tsx": 1157,
	"./template.volcanobet": 1158,
	"./template.volcanobet.tsx": 1158,
	"./template.wellbet": 1159,
	"./template.wellbet.tsx": 1159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2436;